import React, { useEffect, useState } from 'react';
import { ProductsCreatedDto } from 'src/store/products/product';
import Chart from 'react-apexcharts';
import { formatDateShortDayName } from 'src/utils/date';
import { useTranslation } from 'react-i18next';

type Props = {
  productsCreated: ProductsCreatedDto[];
};

export const ProductsCreatedChart: React.FC<Props> = ({ productsCreated }) => {
  const { t } = useTranslation();

  const [series, setSeries] = useState<ApexAxisChartSeries>([
    {
      name: t('product.produced'),
      data: []
    }
  ]);

  const [max, setMax] = useState<number>(20);

  const chartOptions: ApexCharts.ApexOptions = {
    chart: {
      type: 'line'
    },
    title: {
      text: t('product.producedAmount')
    },
    colors: ['var(--primary-color)'],
    yaxis: {
      forceNiceScale: true,
      showForNullSeries: false,
      min: 0,
      max: max
    }
  };

  useEffect(() => {
    const series: ApexAxisChartSeries = [
      {
        name: t('product.produced'),
        data: productsCreated.map(p => ({
          x: formatDateShortDayName(p.date),
          y: p.producedAmount
        }))
      }
    ];
    setMax(Math.max(...productsCreated.map(x => x.producedAmount)) + 1000);
    setSeries(series);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productsCreated]);

  return (
    <Chart type="line" options={chartOptions} series={series} height={300} />
  );
};
